module.exports = __webpack_public_path__ + "img/76.23f3f3bd.jpg";